import { graphqlClient } from '../../graphql/graphql'
import { ORGANIZER_ORDER_INFORMATION, TICKETS_INVENTORY } from '../../graphql/queries/order'
import { CHECK_IN, CHECK_IN_MANUAL, SEND_TICKET_ATTENDEE, DELETE_TICKET, UPDATE_ATTENDEE } from '../../graphql/mutations/order'
import Vue from 'vue';

/**
 * Función para obtener las ordenes de una organización
 */
export const fetchOrdersInformation = async({ commit }, id) => {
    let { data: { organizerOrders } } = await graphqlClient.query({
        query: ORGANIZER_ORDER_INFORMATION,
        fetchPolicy: 'no-cache'
    })
    commit('setOrderInformation', organizerOrders)
}

/**
 * Función para obtener las ventas de un evento en especifico para mostrarlas en la gráfica circular.
 * @param {String} eventId Identificador del evento seleccionado en la gráfica.
 */
export const fetchSalesPerEventApi = async({ commit }, eventId) => {
    let { data } = await Vue.axios({
        method: 'POST',
        url: '/api/orders/totalSalesEvent',
        data: { eventId }
    });
    commit('setOrdersEventDoughnutChart', data);
}

/**
 * Query para obtener bloques de 400 transacciones de un evento (El evento se selecciona en el v-select de las últimas trasacciones)
 * @param {Object} paginateData Objeto que tiene la información necesaria para hacer la consulta de las últimas transacciones
 */
export const fetchOrdersPerEventApi = async({ commit }, paginateData) => {
    try {
        let { data } = await Vue.axios({
            method: 'POST',
            url: '/api/orders/ordersPerEvent',
            data: { eventId: paginateData.eventId, recordsQuantity: paginateData.recordsQuantity, pageNumber: paginateData.pageNumber },
        })
        if (paginateData.pageNumber == 1) {
            commit('setOrderInformation', data);
        } else {
            commit('setMoreOrderInformation', data);
        }
    } catch (err) {
        console.log(err);
    }

}

/**
 * Función para hacer checkIn con la cámara del celular
 * @param {Object} checkInData Información que contiene el código que se escaneó {Id de orden, id de asistente}
 */
export const checkIn = async({ commit }, checkInData) => {
    let { data: { checkInAttendee } } = await graphqlClient.mutate({
        mutation: CHECK_IN(checkInData)
    })
    return checkInAttendee
}

/**
 * Función para hacer checkIn de forma manual, desde la lista de asistentes
 * @param {Object} checkInData Información del asistente {Id de orden, id de asistente, estado de checkIn}
 */
export const checkInManual = async({ commit }, checkInData) => {
    let { data: { checkInAttendee } } = await graphqlClient.mutate({
        mutation: CHECK_IN_MANUAL(checkInData)
    })
    return checkInAttendee
}

/**
 * Función que sirve para mandar un boleto de forma manual
 * @param {Object} ticketData Información del asistente {Id de orden, id del asistente}
 */
export const sendTicketManual = async({ commit }, ticketData) => {
    let { data: { ticketAttendee } } = await graphqlClient.mutate({
        mutation: SEND_TICKET_ATTENDEE(ticketData)
    })
    return ticketAttendee
}

/**
 * Función para eliminar un boleto, (AÚN SIN TERMINAR)
 * @param {String} id Identificador de boleto
 */
export const deleteTicket = async({ commit }, id) => {
    let response = await graphqlClient.mutate({
        mutation: DELETE_TICKET(id)
    })
}

/**
 * Query para obtener la lista de los boletos de los eventos disponibles de una organización
 */
export const fetchTicketsInventory = async({ commit }) => {
    let { data: { ticketsInventory } } = await graphqlClient.query({
        query: TICKETS_INVENTORY,
        fetchPolicy: 'no-cache'
    })
    commit('setTicketsInventory', ticketsInventory)
}

/**
 * Función para actualizar datos de un asistente
 * @param {Object} attendee Objecto del asistente que será actializado
 */
export const updateAttendee = async({ commit }, attendee) => {
    let response = await graphqlClient.mutate({
        mutation: UPDATE_ATTENDEE(attendee)
    })
}